// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--cs6wc","mailingList":"footer-module--mailing-list--1oKvD","mailMe":"footer-module--mail-me--2PCLJ"};